import React from 'react';

import { StyledButton } from './button.style';

const Button = (props) => {
  const {
    children,
    sizevalue = 'normal',
    color = 'primary',
    varient = 'normal',
    weight = '500',
    round = 'false',
    focused = false,
    className = '',
    type = 'button',
    flat = 'false',
    buttonMinWidth,
    ...otherProps
  } = props;

  const focusedStyle = focused ? 'focused' : '';

  return (
    <>
      <StyledButton
        className={`${className} btn-wrapper ${focusedStyle}`}
        type={type}
        weight={weight}
        color={color}
        sizevalue={sizevalue}
        varient={varient}
        round={round}
        flat={flat}
        buttonMinWidth={buttonMinWidth}
        {...otherProps}
      >
        {children}
        {props.varient === 'normal' && <div className="borderBottom" />}
      </StyledButton>
    </>
  );
};
export default Button;
